import React from 'react';
import FooterComp from '../components/Footer/Footer';
import HeaderComp from '../components/Header/Header';
import config from '../config/config';
import Faqs from '../components/Faq/Faqs';
import FaqsHeaderwidget from '../components/Faq/FaqsHeaderwidget';
import DownloadButton from '../components/DownloadButton/DownloadButton';
import SetHeaders from '../config/SetHeaders';
import seo from '../config/seo';
import axios from 'axios';
import Head from 'next/head';

const FaqContainer = ({ Header, Body, Footer, response }: any) => {

  const components = (typeName: any, compData: any, key: any) => {
    switch (typeName) {
      case 'connect.page-heading-widget':
        return <FaqsHeaderwidget key={key} data={compData} />;
      case 'faq.faq-widget':
        return <Faqs key={key} data={compData} />;
      case 'faq.button-with-label':
        return <DownloadButton key={key} data={compData} />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {response && !response.Seo && (
        <Head>
          <title>{seo.faq}</title>
        </Head>
      )}
      {response && <SetHeaders HEADERS={response} />}
      {Header && <HeaderComp HeaderValue={Header} />}
      <div className="app-body">
        {Body &&
          Body.map((data: any, i: number) => {
            return components(data.__component, data, i);
          })}
      </div>
      {Footer && <FooterComp data={Footer} />}
    </React.Fragment>
  );
};

export async function getStaticProps() {
  const { data } = await axios.get(config.endpoints.faq)
  return {
    props: {
      Header: data.Header,
      Body: data.Body,
      Footer: data.Footer.Footer,
      response: data
    },
    revalidate: 3600
  }
}

export default FaqContainer
